<script>
export default {
  props: {
    index: {
      type: Number,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    price: {
      type: Number,
      default: null,
    },
    quantity: {
      type: Number,
      default: null,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    splitBill: {
      type: Boolean,
      default: false,
    },
    choices: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    priceString() {
      return this.price.toLocaleString('en-GB', {
        style: 'currency',
        currency: 'GBP',
      })
    },
  },
  methods: {
    formatPrice(price) {
      return price.toLocaleString('en-GB', {
        style: 'currency',
        currency: 'GBP',
      })
    },
  },
}
</script>

<template>
  <div :class="$style.billItemWrapper">
    <div v-if="splitBill" :class="$style.billItem">
      <div :class="$style.itemToPay">
        <BaseCheckbox
          type="checkbox"
          :name="`itemToPay-${name}`"
          :checked="selected"
        />
        <label
          :for="`itemToPay-${name}`"
          :class="{ [$style.checked]: selected }"
          @click="$emit('on-check', index)"
        >
          <!-- Item -->
          <div v-if="name" :class="$style.billItem">
            <div :class="$style.name">
              <span v-if="quantity > 1">x {{ quantity }} </span>{{ name }}
            </div>
            <div v-if="price || price === 0" :class="$style.price">
              {{ priceString }}
            </div>
          </div>
          <!-- Choices -->
          <div
            v-for="choice in choices"
            :key="choice.key"
            :class="$style.choiceItemWrapper"
          >
            <div v-if="choice.name" :class="$style.choiceItem">
              <div :class="$style.name">{{ choice.name }}</div>
              <div
                v-if="choice.price || choice.price === 0"
                :class="$style.price"
              >
                {{ formatPrice(choice.price) }}
              </div>
            </div>
            <!-- Choices anded -->
            <div
              v-for="anded in choice.choices"
              :key="anded.key"
              :class="$style.choiceItemWrapper"
            >
              <div v-if="anded.name" :class="$style.choiceItem">
                <div :class="$style.name">{{ anded.name }}</div>
                <div
                  v-if="anded.price || anded.price === 0"
                  :class="$style.price"
                >
                  {{ formatPrice(anded.price) }}
                </div>
              </div>
              <!-- Choices anded anded -->
              <div
                v-for="andedAnded in anded.choices"
                :key="andedAnded.key"
                :class="$style.choiceItemWrapper"
              >
                <div v-if="andedAnded.name" :class="$style.choiceItem">
                  <div :class="$style.name">{{ andedAnded.name }}</div>
                  <div
                    v-if="andedAnded.price || andedAnded.price === 0"
                    :class="$style.price"
                  >
                    {{ formatPrice(andedAnded.price) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </label>
      </div>
    </div>
    <template v-else>
      <!-- Item -->
      <div :class="$style.billItem">
        <div :class="$style.name">
          <span v-if="quantity > 1">x {{ quantity }} </span>{{ name }}
        </div>
        <div v-if="price || price === 0" :class="$style.price">
          {{ priceString }}
        </div>
      </div>
      <!-- Choices -->
      <div
        v-for="choice in choices"
        :key="choice.key"
        :class="$style.choiceItemWrapper"
      >
        <div v-if="choice.name" :class="$style.choiceItem">
          <div :class="$style.name">{{ choice.name }}</div>
          <div v-if="choice.price || choice.price === 0" :class="$style.price">
            {{ formatPrice(choice.price) }}
          </div>
        </div>
        <!-- Choices anded -->
        <div
          v-for="anded in choice.choices"
          :key="anded.key"
          :class="$style.choiceItemWrapper"
        >
          <div v-if="anded.name" :class="$style.choiceItem">
            <div :class="$style.name">{{ anded.name }}</div>
            <div v-if="anded.price || anded.price === 0" :class="$style.price">
              {{ formatPrice(anded.price) }}
            </div>
          </div>
          <!-- Choices anded anded -->
          <div
            v-for="andedAnded in anded.choices"
            :key="andedAnded.key"
            :class="$style.choiceItemWrapper"
          >
            <div v-if="andedAnded.name" :class="$style.choiceItem">
              <div :class="$style.name">{{ andedAnded.name }}</div>
              <div
                v-if="andedAnded.price || andedAnded.price === 0"
                :class="$style.price"
              >
                {{ formatPrice(andedAnded.price) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.billItemWrapper {
  width: 100%;
  margin-bottom: 1rem;
  line-height: 1rem;
}

.billItem {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1rem;
  line-height: 1rem;

  &:last-child {
    margin: 0;
  }
}

.choiceItemWrapper {
  width: 100%;
  margin-bottom: 0.5rem;
  line-height: 1rem;

  &:last-child {
    margin: 0;
  }
}

.choiceItem {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.5rem;
  line-height: 1rem;
  font-size: 0.8rem;

  &:last-child {
    margin: 0;
  }
}

.name {
  text-transform: uppercase;
  text-align: left;
  width: 100%;
}

.price {
  text-align: right;
  width: 80px;
  margin-left: auto;
}

.itemToPay {
  display: flex;
  margin: 0;
  font-weight: bold;
  text-align: left;

  input {
    position: absolute;
    z-index: -1;
    opacity: 0;
  }

  label {
    margin-left: 16px;
    padding-left: 12px;
    position: relative;
    width: calc(100vw - 96px);

    &:before,
    &:after {
      position: absolute;
      content: '';
    }

    &:before {
      width: 20px;
      height: 20px;
      border: var(--color-primary) 2px solid;
      background-color: #ffffff;
      left: -16px;
    }

    &:after {
      height: 0.3125rem;
      width: 0.75rem;
      border-left: 2px solid;
      border-bottom: 2px solid;
      color: #fff;

      transform: rotate(-53deg);

      left: -12px;
      top: 6px;
    }

    &.checked {
      &:before {
        background: var(--color-primary);
      }
    }
  }
}
</style>
